import { Directive, Input, Output, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { LazyLoadService, LOADING_STRATEGY } from '@abp/ng.core';
import { LayoutStateService } from '../services/layout-state.service';

import { take } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';

/**
 * 动态加载metronic主题文件
 */
@Directive({
	selector: '[hedouMtSty]'
})
export class MtStyDirective implements OnInit, OnDestroy {

	
	stylesLoaded$: any;
	constructor(
		private layoutState: LayoutStateService,
		private lazyLoadService: LazyLoadService) {

	}

	ngOnDestroy(): void {
		this.lazyLoadStyle();
	}

	ngOnInit(): void {

	}

	lazyLoadStyle() {
		this.layoutState.get$('themeSettings')
			.pipe(take(1))
			.subscribe((theme) => {

				this.stylesLoaded$ = forkJoin(
					[
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead('/assets/metronic1/css/style.bundle.min.css')),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/aside/${theme.asideMenuColor}.min.css`)),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/brand/${theme.brandColor}.min.css`)),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/header/base/${theme.headerColor}.min.css`)),
						this.lazyLoadService.load(LOADING_STRATEGY.PrependAnonymousStyleToHead(`/assets/global/themes/layout/header/menu/${theme.headerMenuColor}.min.css`))
					]
				)
			});
	}

}
